export function sleep(ms, abortSignal) {
    return new Promise((resolve) => {
        const timer = setTimeout(resolve, ms);
        if (abortSignal) {
            abortSignal.onabort = () => {
                clearTimeout(timer);
            };
        }
    });
}
//# sourceMappingURL=timer.js.map